import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import '../../MainDash/Alerts/AlertInfoPage.css';
import '../../MainDash/Alerts/AlertPage.css';
import '../../MainDash/NewHome.css';
import '../../MainDash/Alerts/AssignAlert.css';
import Attach from '../../../images/attach.png';
import { IconButton } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import AlertModal from '../../MainDash/Alerts/AlertModal';
import { BuildingDropdown } from './BuildingDropdown';
import Authenticate from '../../../services/Authenticate';
import { useEffect } from 'react';
import axios from 'axios';


const API_URL = process.env.REACT_APP_API_URL || "https://mybuildingalerts.com/";
const Report = ({type}) => {
    const history = useHistory();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [description, setDescription] = useState("");
    const [optionalPhoto, setOptionalPhoto] = useState(null);
    const [optionalPhotoName, setOptionalPhotoName] = useState('');
    const [contactPreference, setContactPreference] = useState('');
    const [email, setEmail] = useState('');
    const [selectedBuildings, setSelectedBuildings] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState("");
    const [isDangerous, setIsDangerous] = useState('');

    // const [selectedTenants, setSelectedTenants] = useState([]);
    useEffect(() => {
        if (isSubmitting) {
            setIsModalOpen(true)
        }
    }, [isSubmitting])
    const handleFileChange = (event) => {
        const { files } = event.target;
        if (files.length > 0) {
            const file = files[0];
            setOptionalPhoto(file);
            setOptionalPhotoName(file.name);
        }
    };

    const handleContactPreferenceChange = (event) => {
        setContactPreference(event.target.value);
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleBuildingChange = (value) => {
        setSelectedBuildings(value);
    };

    // const handleTenantChange = (value) => {
    //     setSelectedTenants(value);
    //   };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsSubmitting(true);
    
        try {
            // Validate required fields
            if (!description || selectedBuildings.length === 0) {
                setError('Description and building are required.');
                setIsSubmitting(false);
                return;
            }
    
            const formData = new FormData();
            formData.append('description', description);
            formData.append('buildingId', selectedBuildings);
            formData.append('type', type);
            formData.append('contactEmail', contactPreference);
            if (email) {
                formData.append('email', email);
            }
            if (optionalPhoto) {
                formData.append('photo', optionalPhoto);
            }
            if (type === "Report a Condition") {
                formData.append('isDangerous', isDangerous);
            }
    
            // Debug: log formData entries
            // for (let [key, value] of formData.entries()) {
            //     console.log(key, value);
            // }
    
            const response = await axios.post(`${API_URL}/serviceRequests/createRequest`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
                
            });
    
            console.log('Service request submitted:', response.data);
            // Reset form and navigate
            setDescription('');
            setOptionalPhoto(null);
            setOptionalPhotoName('');
            setContactPreference('');
            setEmail('');
            setSelectedBuildings('');
            history.push("/Home");
        } catch (err) {
            console.error('Error submitting service request:', err);
            setError('Failed to submit service request. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };
    

    return (
        <>
            <div className='FeedbackPage'>
                <div className='alerts-section'>
                    <div className="alerts-header">
                        <div className="title-container">
                            <IconButton onClick={() => history.push('/Home')}>
                                <ArrowBackIosNewIcon
                                    className="z-0"
                                    style={{ color: 'rgb(14, 81, 46)' }}
                                />
                            </IconButton>
                            <h2>Create a {type}</h2>
                            <div className="placeholder" style={{ width: '40px', backgroundColor: 'transparent' }}></div>
                        </div>
                    </div>
                    <div className='feedback-content'style={{gap: '16px'}}>
                        <div style={{width: '100%'}}>
                        {type === "Report a Condition" && (
                            <div style={{ width: '100%', marginBottom: '16px' }}>
                                <h2 className='input-header'>Is the condition dangerous or unsafe?</h2>
                                <div className="contact-preference">
                                    <label>
                                        <input
                                            type="radio"
                                            value="yes"
                                            checked={isDangerous === 'yes'}
                                            onChange={(e) => setIsDangerous(e.target.value)}
                                        />
                                        Yes
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            value="no"
                                            checked={isDangerous === 'no'}
                                            onChange={(e) => setIsDangerous(e.target.value)}
                                        />
                                        No
                                    </label>
                                </div>
                            </div>
                        )}
                            <h2 className='input-header'>Please provide details:</h2>
                            <textarea
                                type="text"
                                placeholder="Type your feedback"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                            <label htmlFor="photo-upload" className='photo-label' style={{fontSize: '16px'}}>
                                <img
                                    src={Attach}
                                    alt="upload icon"
                                    style={{ height: '20px', marginLeft: '10px' }}
                                />
                                {optionalPhotoName ? optionalPhotoName : 'Attach a screenshot/photo (optional)'}
                                <input
                                    type="file"
                                    id="photo-upload"
                                    accept="image/*"
                                    style={{ padding: '5px', marginTop: '5px' }}
                                    onChange={handleFileChange}
                                />
                            </label>
                        </div>
                       
                        <div>
                        <h2 className='input-header'>Where is the issue located?</h2>
                        <BuildingDropdown 
                            selectedBuildings={selectedBuildings} 
                            onBuildingChange={handleBuildingChange} 
                        />
                        </div>   

                        <div style={{width: '100%'}}>
                            <h2 className='input-header'>Would you like to be contacted?</h2>
                            <div className="contact-preference">
                                <label>
                                    <input
                                        type="radio"
                                        value="yes"
                                        checked={contactPreference === 'yes'}
                                        onChange={handleContactPreferenceChange}
                                    />
                                    Yes
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="no"
                                        checked={contactPreference === 'no'}
                                        onChange={handleContactPreferenceChange}
                                    />
                                    No
                                </label>
                            </div>
                        </div>

                        {contactPreference === 'yes' && (
                            <div style={{width: '100%'}}>
                                <h2 className='input-header'>Enter your email address</h2>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={handleEmailChange}
                                />
                            </div>
                        )}

                        <div className='alert-button-container'>
                            <button className='alert-info-button' 
                                onClick={handleSubmit}
                                style={{padding: '0.5em 1.25em', fontSize: '18px', marginBottom: '20px'}}>
                                Submit {type}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <AlertModal
                isModalOpen={isModalOpen}
                closeModal={() => setIsModalOpen(false)}
                confirmModal={() => history.push('/Home')}
                handleOptionClick={() => { }}
                height="200px"
                style={{zIndex: 1300}}
                title="Report Sent!"
                options={[]}
            >
                <button className="modal-button alert-confirm" onClick={() => history.push('/Home')}>Return to Home</button>
            </AlertModal>
        </>
    );
};

export default Report;
